function Lightbox(element) {
    const imgUrl = element.href;

    this.anchor = element;

    this.lightbox = document.createElement('div');
    this.lightbox.classList.add('lightbox');
    this.lightbox.style.opacity = 0;

    const lightboxInner = document.createElement('div');
    lightboxInner.classList.add('lightbox__inner');
    lightboxInner.classList.add('jsCloseLightbox');
    this.lightbox.appendChild(lightboxInner);

    const contentWrapper = document.createElement('div');
    contentWrapper.classList.add('lightbox__content-wrapper');
    lightboxInner.appendChild(contentWrapper);

    const closeBtn = document.createElement('button');
    closeBtn.classList.add('lightbox__close-btn');
    closeBtn.classList.add('jsCloseLightbox');
    closeBtn.type = 'button';
    closeBtn.innerHTML = 'Close';
    contentWrapper.appendChild(closeBtn);

    const img = document.createElement('img');
    img.src = imgUrl;
    contentWrapper.appendChild(img);

    // Add the lightbox to the DOM
    document.body.appendChild(this.lightbox);

    // Add event listeners
    this.lightbox.addEventListener('click', e => {
        if (e.target.classList.contains('jsCloseLightbox')) this.hide();
    });

    // Add escape close listener
    this.bindKeyupEvent = this.keyUp.bind(this);
    document.addEventListener('keyup', this.bindKeyupEvent, true);
};

Lightbox.prototype.keyUp = function(e) {
    switch (e.keyCode) {
        case 27 : this.hide(); break;
        case 37 : this.switchPhoto(false); break;
        case 39 : this.switchPhoto(true); break;
    }
};

Lightbox.prototype.show = function() {
    document.body.classList.add('no-overflow');

    TweenLite.to(this.lightbox, 0.3, { opacity: 1, ease: Power2.easeInOut, onComplete: _ => {
        TweenLite.set(this.lightbox, { clearProps: 'all' });
    } });
};

Lightbox.prototype.hide = function() {
    TweenLite.to(this.lightbox, 0.3, { opacity: 0, ease: Power2.easeInOut, onComplete: _ => {
        document.body.classList.remove('no-overflow');
        document.body.removeChild(this.lightbox);
        document.removeEventListener('keyup', this.bindKeyupEvent, true);
    } });
};

Lightbox.prototype.switchPhoto = function(isNext) {
    const group = this.anchor.dataset.lightboxGroup;
    if (group === undefined) return;

    const groupItems = [...document.querySelectorAll('[data-lightbox-group="' + group + '"]')];
    if (groupItems.length <= 1) return;

    const currentIndex = groupItems.indexOf(this.anchor);

    let nextAnchor = groupItems[((currentIndex + 1) > (groupItems.length - 1)) ? 0 : currentIndex + 1];
    if (! isNext) nextAnchor = groupItems[((currentIndex - 1) < 0) ? groupItems.length - 1 : currentIndex - 1];
    if (nextAnchor === undefined) return;

    this.lightbox.querySelector('img').src = nextAnchor.href;
    this.anchor = nextAnchor;
};